import React from "react";
import InformationCard from "./informationCard";

const information = {
  "Flat Fee": `<p>Donors pay no extra on top of their donation</p>
  <p>Payment processing fee is taken out of the donation</p>
  <p>4.9% Chuffed.org platform fee</p>`,
  Shared: `<p>0% Chuffed.org platform fee</p>
  <p>Donors can choose to give an optional donation to Chuffed.org</p>
  <p>Payment processing fee is taken out of the donation</p>`,
  "Keep 100": `<p>You keep 100% of the donation</p>
  <p>Donors pay payment processing fees</p>
  <p>Donors can choose to give an optional donation to Chuffed.org</p>
  <p>0% Chuffed.org platform fee</p>`,
};

const PaymentModelInformation = ({
  paymentModel,
}) => {
  const modelInformation = (model) => information[model];

  return (
    <div className="fees__payment-model-information">
      <InformationCard
        paymentModel={paymentModel}
        title={paymentModel}
        information={modelInformation(paymentModel)}
      />
    </div>
  );
};

export default PaymentModelInformation;
